import React, { useState } from 'react';
import { TimePeriodTypeEnum } from '../Enum/TimePeriodTypeEnum';

const AnalyticContext = React.createContext<any>(null);


export const AnalyticProvider = ({ children }: { children: React.ReactNode }) => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [
        (currentYear - 1).toString(), // previous year
        "0" // baseline
    ];
    const monthOptions = Array.from({ length: 12 }, (_, i) => i + 1);

    const [tcPopulation, setTcPopulation] = useState(0);
    const [tcHealthPlanIds, setTcHealthPlanIds] = useState<string[]>([]);
    const [tcMemberStatus, setTcMemberStatus] = useState(2);
    const [tcTimePeriod, setTcTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [tcPart, setTcPart] = useState(0);
    const [tcTeam, setTcTeam] = useState('All');
    const [showTcInActiveTeams, setShowTcInActiveTeams] = useState(false);
    const [tcYears, setTcYears] = useState<string[]>(yearOptions.map(String));
    const [tcMonths, setTcMonths] = useState<string[]>(monthOptions.map(String));

    const [acPopulation, setAcPopulation] = useState(0);
    const [acHealthPlanIds, setAcHealthPlanIds] = useState<string[]>([]);
    const [acMemberStatus, setAcMemberStatus] = useState(2);
    const [acTimePeriod, setAcTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [acPart, setAcPart] = useState(0);
    const [acTeam, setAcTeam] = useState('All');
    const [showAcInActiveTeams, setShowAcInActiveTeams] = useState(false);
    const [acYears, setAcYears] = useState<string[]>(yearOptions.map(String));
    const [acMonths, setAcMonths] = useState<string[]>(monthOptions.map(String));

    const [phPopulation, setPhPopulation] = useState(0);
    const [phHealthPlanIds, setPhHealthPlanIds] = useState<string[]>([]);
    const [phMemberStatus, setPhMemberStatus] = useState(2);
    const [phTimePeriod, setPhTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [phPart, setPhPart] = useState(0);
    const [phTeam, setPhTeam] = useState('All');
    const [showPhInActiveTeams, setShowPhInActiveTeams] = useState(false);
    const [phYears, setPhYears] = useState<string[]>(yearOptions.map(String));
    const [phMonths, setPhMonths] = useState<string[]>(monthOptions.map(String));

    const [ffPopulation, setFfPopulation] = useState(0);
    const [ffHealthPlanIds, setFfHealthPlanIds] = useState<string[]>([]);
    const [ffMemberStatus, setFfMemberStatus] = useState(2);
    const [ffTimePeriod, setFfTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [ffPart, setFfPart] = useState(0);
    const [ffTeam, setFfTeam] = useState('All');
    const [showFfInActiveTeams, setShowFfInActiveTeams] = useState(false);
    const [ffYears, setFfYears] = useState<string[]>(yearOptions.map(String));
    const [ffMonths, setFfMonths] = useState<string[]>(monthOptions.map(String));

    const [bhRtcPopulation, setBhRtcPopulation] = useState(0);
    const [bhRtcHealthPlanIds, setBhRtcHealthPlanIds] = useState<string[]>([]);
    const [bhRtcMemberStatus, setBhRtcMemberStatus] = useState(2);
    const [bhRtcTimePeriod, setBhRtcTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [bhRtcPart, setBhRtcPart] = useState(0);
    const [bhRtcTeam, setBhRtcTeam] = useState('All');
    const [showBhRtcInActiveTeams, setShowBhRtcInActiveTeams] = useState(false);
    const [bhRtcYears, setBhRtcYears] = useState<string[]>(yearOptions.map(String));
    const [bhRtcMonths, setBhRtcMonths] = useState<string[]>(monthOptions.map(String));

    const [edPopulation, setEdPopulation] = useState(0);
    const [edHealthPlanIds, setEdHealthPlanIds] = useState<string[]>([]);
    const [edMemberStatus, setEdMemberStatus] = useState(2);
    const [edTimePeriod, setEdTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [edPart, setEdPart] = useState(0);
    const [edTeam, setEdTeam] = useState('All');
    const [showEdInActiveTeams, setShowEdInActiveTeams] = useState(false);
    const [edYears, setEdYears] = useState<string[]>(yearOptions.map(String));
    const [edMonths, setEdMonths] = useState<string[]>(monthOptions.map(String));


    const [costSummaryPopulation, setCostSummaryPopulation] = useState(0);
    const [costSummaryHealthPlanIds, setCostSummaryHealthPlanIds] = useState<string[]>([]);
    const [costSummaryMemberStatus, setCostSummaryMemberStatus] = useState(2);
    const [costSummaryTimePeriod, setCostSummaryTimePeriod] = useState(TimePeriodTypeEnum.YRS);
    const [costSummaryPart, setCostSummaryPart] = useState(0);
    const [costSummaryTeam, setCostSummaryTeam] = useState('All');
    const [showCostSummaryInActiveTeams, setShowCostSummaryInActiveTeams] = useState(false);
    const [costSummaryTab, setCostSummaryTab] = useState(1);
    const [costSummaryYears, setCostSummaryYears] = useState<string[]>(yearOptions.map(String));
    const [costSummaryMonths, setCostSummaryMonths] = useState<string[]>(monthOptions.map(String));

    const value = {
        tcPopulation,
        setTcPopulation,
        tcHealthPlanIds,
        setTcHealthPlanIds,
        tcMemberStatus,
        setTcMemberStatus,
        tcTimePeriod,
        setTcTimePeriod,
        tcPart,
        setTcPart,
        tcTeam,
        setTcTeam,
        showTcInActiveTeams,
        setShowTcInActiveTeams,
        tcYears,
        setTcYears,
        tcMonths,
        setTcMonths,

        acPopulation,
        setAcPopulation,
        acHealthPlanIds,
        setAcHealthPlanIds,
        acMemberStatus,
        setAcMemberStatus,
        acTimePeriod,
        setAcTimePeriod,
        acPart,
        setAcPart,
        acTeam,
        setAcTeam,
        showAcInActiveTeams,
        setShowAcInActiveTeams,
        acYears,
        setAcYears,
        acMonths,
        setAcMonths,

        phPopulation,
        setPhPopulation,
        phHealthPlanIds,
        setPhHealthPlanIds,
        phMemberStatus,
        setPhMemberStatus,
        phTimePeriod,
        setPhTimePeriod,
        phPart,
        setPhPart,
        phTeam,
        setPhTeam,
        showPhInActiveTeams,
        setShowPhInActiveTeams,
        phYears,
        setPhYears,
        phMonths,
        setPhMonths,

        ffPopulation,
        setFfPopulation,
        ffHealthPlanIds,
        setFfHealthPlanIds,
        ffMemberStatus,
        setFfMemberStatus,
        ffTimePeriod,
        setFfTimePeriod,
        ffPart,
        setFfPart,
        ffTeam,
        setFfTeam,
        showFfInActiveTeams,
        setShowFfInActiveTeams,
        ffYears,
        setFfYears,
        ffMonths,
        setFfMonths,

        bhRtcPopulation,
        setBhRtcPopulation,
        bhRtcHealthPlanIds,
        setBhRtcHealthPlanIds,
        bhRtcMemberStatus,
        setBhRtcMemberStatus,
        bhRtcTimePeriod,
        setBhRtcTimePeriod,
        bhRtcPart,
        setBhRtcPart,
        bhRtcTeam,
        setBhRtcTeam,
        showBhRtcInActiveTeams,
        setShowBhRtcInActiveTeams,
        bhRtcYears,
        setBhRtcYears,
        bhRtcMonths,
        setBhRtcMonths,

        edPopulation,
        setEdPopulation,
        edHealthPlanIds,
        setEdHealthPlanIds,
        edMemberStatus,
        setEdMemberStatus,
        edTimePeriod,
        setEdTimePeriod,
        edPart,
        setEdPart,
        edTeam,
        setEdTeam,
        showEdInActiveTeams,
        setShowEdInActiveTeams,
        edYears,
        setEdYears,
        edMonths,
        setEdMonths,

        costSummaryPopulation,
        setCostSummaryPopulation,
        costSummaryHealthPlanIds,
        setCostSummaryHealthPlanIds,
        costSummaryMemberStatus,
        setCostSummaryMemberStatus,
        costSummaryTimePeriod,
        setCostSummaryTimePeriod,
        costSummaryPart,
        setCostSummaryPart,
        costSummaryTeam,
        setCostSummaryTeam,
        showCostSummaryInActiveTeams,
        setShowCostSummaryInActiveTeams,
        costSummaryTab,
        setCostSummaryTab,
        costSummaryYears,
        setCostSummaryYears,
        costSummaryMonths,
        setCostSummaryMonths
    };

    return <AnalyticContext.Provider value={value}>{children}</AnalyticContext.Provider>;
};

export const useAnalyticContext = () => React.useContext(AnalyticContext);

